import "./scss/style.scss";
import "./scss/tooltip.scss";
import "./scss/title.scss";
import "./scss/DraggableModal.scss";
import "./scss/MobileKeyboard.scss";
import "./scss/FinishMessage.scss";
import "./scss/transition.scss";
import App from "./js/App.js";

window.onload = () => {
  new App();
};
